import React, { memo, useEffect } from "react"
import Aos from "aos"
import SectionsTitle from "../../Common/new/SectionsTitle"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import "react-tabs/style/react-tabs.css"
import parse from "html-react-parser"
import * as style from "./guide.module.css"
import { replaceUnderscoresWithSpaces } from "../../utils/functions"

const Guide = ({
  serviceListOfUserGuide,
  userGuideShowSection,
  userGuideTitle,
  userGuideSubTitle,
  userGuideContent,
}) => {
  useEffect(() => {
    Aos.init({
      once: true,
    })
  }, [])

  return (
    <>
      {userGuideShowSection == "yes" && (
        <section className={`${style.guide_section}`}>
          <div className="container">
            <div className="row">
              <div className={style.guideWrapper}>
                <SectionsTitle
                  title={replaceUnderscoresWithSpaces(userGuideTitle)}
                  SubTitle={userGuideSubTitle}
                  Content={userGuideContent}
                  styleCss={{ display: "none" }}
                />
                <div
                  className={style.tabBox}
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <Tabs>
                    <div className={style.leftTabbox}>
                      <TabList>
                        {serviceListOfUserGuide?.map(items => {
                          return (
                            <Tab key={items?.userGuideTabTitle}>
                              <h3>{items?.userGuideTabTitle}</h3>
                            </Tab>
                          )
                        })}
                      </TabList>
                    </div>
                    <div className={style.rightTabContent}>
                      {serviceListOfUserGuide?.map(items => {
                        return (
                          <TabPanel key={items?.userGuideTabContent}>
                            <div className={style.innerTabContent}>
                              <div>
                                <h3>{items?.userGuideTabTitle}</h3>
                                <p>{parse(`${items?.userGuideTabContent}`)}</p>
                              </div>
                              <ul className={style.ulList}>
                                {items?.userGuideTabListing?.map(item => {
                                  return (
                                    <li key={item?.userGuideTabMainText}>
                                      <span>{item?.userGuideTabMainText}</span>
                                      {parse(`${items?.userGuideTabContent}`)}
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </TabPanel>
                        )
                      })}
                    </div>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(Guide)
